import { Navigation } from '@/Interfaces';
import { useState } from 'react';
 
export const useNavigation = (initialNavigation: Navigation = {}) => {
    const [navigation, setNavigation] = useState<Navigation>(initialNavigation);

    const updateNavigation = (newNavigation: Partial<Navigation>) => {
        setNavigation(prev => ({
            ...prev,
            ...newNavigation
        }));
    };

    return { navigation, updateNavigation };
};
